//TODO - this can be ripped out when abstract.storage.js comes out. Also, these files are called in app-template and all other front-end apps in app/configuration/storage.configuration.js

define('evicommon/storage/cookie.storage',['require','exports','module','./abstract.storage'],function(require, exports, module) {
  var AbstractStorage = require('./abstract.storage');

  var CookieStorage = AbstractStorage.extend({});

  module.exports = CookieStorage;
});

